<!-- src/components/SiteFooter.vue -->
<template>
  <footer class="site-footer" role="contentinfo">
    <div class="container">
      <p class="legal">
        © {{ year }} Funda Tu Sitio Web. Todos los derechos reservados.
      </p>
      <p class="notice">
        Este demo/herramienta procesa todo localmente en tu navegador:
        <strong>no subimos ni almacenamos tus imágenes, metadatos ni resultados</strong> en nuestros servidores.
        Los archivos que guardes se crean directamente en tu dispositivo.
      </p>
      <p class="disclaimer">
        Usa material con derechos sólo si tienes permiso. Limpia la caché del navegador si deseas eliminar restos temporales.
      </p>
    </div>
  </footer>
</template>

<script setup>
const year = new Date().getFullYear()
</script>

<style scoped lang="scss">
.site-footer {
  --_panel: var(--panel, #0f131a);
  --_panel2: var(--panel-2, #111722);
  --_border: var(--border, #243042);
  --_text: var(--text, #e6e9ef);
  --_muted: var(--muted, #9aa4b2);

  background: linear-gradient(180deg, var(--_panel2), var(--_panel));
  border-top: 1px solid var(--_border);
  color: var(--_muted);
  padding: 18px 16px;
  font-size: 14px;
}

.container {
  max-width: 1120px;
  margin: 0 auto;
  display: grid;
  gap: 6px;
}

.legal {
  margin: 0;
  color: var(--_text);
  font-weight: 600;
}

.notice {
  margin: 0;
  line-height: 1.5;
}

.disclaimer {
  margin: 0;
  opacity: .85;
  font-size: 13px;
}
</style>
